import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import hubExpertRessourcesRedigerProgrammeDeFormationStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'hubExpertRessourcesRedigerProgrammeDeFormation'
const customImplement: CustomStoreImplementationOptions = hubExpertRessourcesRedigerProgrammeDeFormationStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function hubExpertRessourcesRedigerProgrammeDeFormationFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-2-prog-de-formation.title', 'Rédiger un programme de formation'),
        $description: $translate('expert-ressource-2-prog-de-formation.description', 'Création de parties, fil conducteur, ordre... avec Matchers, soyez sûrs d\'avoir toutes les cartes en main pour établir un programme de formation réussi !'),
        $publishedTime: new Date('2023-02-13T07:42:17.679Z'),
        $modifiedTime: new Date('2023-11-20T14:14:08.336Z'),
        // Constants,
        $constants: {
          question1Hidden: false,
          question1Hidden1: null,
          question2Hidden: false,
          question2Hidden1: null,
          question3Hidden: false,
          question3Hidden1: null,
          question4Hidden: false,
          question4Hidden1: null,
          question5Hidden: false,
          question5Hidden1: null,
          question6Hidden: false,
          question6Hidden1: null,
          question7Hidden: false,
          question7Hidden1: null,
          question8Hidden: false,
          question8Hidden1: null,
          question9Hidden: false,
          question9Hidden1: null,
          verbeConnaissanceHidden: false,
          k4ObjectifsTxtHidden: false,
          k4ObjectifsTxtHidden1: null,
          k4EtapesTxtHidden: false,
          k4EtapesTxtHidden1: null,
          k6ConseilsTxtHidden: false,
          k6ConseilsTxtHidden1: null
        },
        // Data,
        $info: { expertRessource2ProgDeFormation: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async ltToutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container4Click () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container4ClickWhenSelected () {
        this.$elements['question-2'].style = { hidden: this.$constants.question2Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container7Click () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container7ClickWhenSelected () {
        this.$elements['question-3'].style = { hidden: this.$constants.question3Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10Click () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container10ClickWhenSelected () {
        this.$elements['question-4'].style = { hidden: this.$constants.question4Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16Click () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container16ClickWhenSelected () {
        this.$elements['question-5'].style = { hidden: this.$constants.question5Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19Click () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container19ClickWhenSelected () {
        this.$elements['question-6'].style = { hidden: this.$constants.question6Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container22Click () {
        this.$elements['question-7'].style = { hidden: this.$constants.question7Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container22ClickWhenSelected () {
        this.$elements['question-7'].style = { hidden: this.$constants.question7Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container25Click () {
        this.$elements['question-8'].style = { hidden: this.$constants.question8Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container25ClickWhenSelected () {
        this.$elements['question-8'].style = { hidden: this.$constants.question8Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container40Click () {
        this.$elements['question-9'].style = { hidden: this.$constants.question9Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container40ClickWhenSelected () {
        this.$elements['question-9'].style = { hidden: this.$constants.question9Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      icon6Click () {
        this.$elements['verbe-connaissance'].style = { hidden: this.$constants.verbeConnaissanceHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text7Click () {
        await navigateTo({ hash: '#creation-programme--p45' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text8Click () {
        await navigateTo({ hash: '#k-4-objectifs--p45' })
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClick () {
        this.$elements['k-4-objectifs-txt'].style = { hidden: this.$constants.k4ObjectifsTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClickWhenSelected () {
        this.$elements['k-4-objectifs-txt'].style = { hidden: this.$constants.k4ObjectifsTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text9Click () {
        await navigateTo({ hash: '#structure--p45' })
      },
      /* @ts-ignore: to allow override in your custom file */
      icon12Click () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      icon12ClickWhenSelected () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text10Click () {
        await navigateTo({ hash: '#k-5-conseils--p45' })
      },
      /* @ts-ignore: to allow override in your custom file */
      icon13Click () {
        this.$elements['k-6-conseils-txt'].style = { hidden: this.$constants.k6ConseilsTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      icon13ClickWhenSelected () {
        this.$elements['k-6-conseils-txt'].style = { hidden: this.$constants.k6ConseilsTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async text11Click () {
        await navigateTo({ hash: '#creation-programme--p45' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async blocPreviewRessourceSansDescriptionClick () {
        await navigateTo({ name: 'hub-expert-Ressources-preparer-rdv-decouverte' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element2Click () {
        await navigateTo({ name: 'Expert-Ressources-organiser-sa-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element3Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return hubExpertRessourcesRedigerProgrammeDeFormationFactory(storeId)()
}

export const hubExpertRessourcesRedigerProgrammeDeFormationRaw = hubExpertRessourcesRedigerProgrammeDeFormationFactory()
export const hubExpertRessourcesRedigerProgrammeDeFormation = () => hubExpertRessourcesRedigerProgrammeDeFormationRaw() as MergeCustomStore<typeof hubExpertRessourcesRedigerProgrammeDeFormationStoreCustom.instance>
